import styled from 'styled-components';
import { ContainerWrapper, Container } from '../Container';
import { API_URL } from '../../config';
import forestImg from '../../assets/images/img-forest.jpg';
import millImg from '../../assets/images/img-truck.jpg';
import multimediaImg from '../../assets/images/img-truck.jpg';
import multispectralImg from '../../assets/images/forest.jpg';
import whatsNew from '../../assets/images/img-trees.jpg';
import landingImg from '../../assets/images/landing_map.jpg'
import droneAppNews from '../../assets/documentation/oldVersion/droneAppNews.pdf';
import droneMillInventory from '../../assets/documentation/oldVersion/droneMillInventory.pdf';
import workingWithDroneForestApp from '../../assets/documentation/oldVersion/workingWithDroneForestApp.pdf';
import multispectralBestPractices from '../../assets/documentation/oldVersion/multispectralBestPractices.pdf';
import droneAppRecommendation from '../../assets/documentation/oldVersion/droneAppRecommendation.pdf';

import millInventory from '../../assets/documentation/newVersion/droneMillInventory.pdf';
import forestInventory from '../../assets/documentation/newVersion/droneForestInventory.pdf';
import droneMultimedia from '../../assets/documentation/newVersion/droneMultimedia.pdf';
import theme from '../../config/theme';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 1rem;
  row-gap: 1rem;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (min-width: 992px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;
const HR = styled.hr`
background: ${theme.colors.text_dark};
border: ${theme.colors.text_dark};
height: 2pt;
`

const Item = styled.a`
  display: block;

  img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    display: block;
  }

  span {
    display: block;
    background-color: ${({theme}) => theme.colors.bg_gray};
    color: ${({theme}) => theme.colors.heading_dark};
    padding: 1.5rem;
    font-size: 1.25rem;
    font-weight: bold;
    border-top: 5px solid ${({theme}) => theme.colors.brand_green};
    transition: all .5s ease;
  }

  &:hover {
    span {
      border-top: 5px solid ${({theme}) => theme.colors.brand_blue};
    }
  }
`;

function Help() {

  return (
    <ContainerWrapper>

      <Container>
      <h3>New Version Documentation</h3>
      <Grid>
          <Item href={millInventory} target="_blank" rel="noopener noreferrer">
            <img src={millImg} alt="What's New" />
            <span>Mill Inventory</span>
          </Item>
         <Item href={forestInventory} target="_blank" rel="noopener noreferrer">
            <img src={forestImg} alt="Mill Inventory" />
            <span>Forest Inventory</span>
        </Item>
        <Item href={droneMultimedia} target="_blank" rel="noopener noreferrer">
            <img src={multispectralImg} alt="Multimedia" />
            <span>Multimedia</span>
        </Item>

        </Grid>

      <HR></HR>
      <h3>Old Version Documentation</h3>
        <Grid>
          <Item href={droneAppNews} target="_blank" rel="noopener noreferrer">
            <img src={whatsNew} alt="What's New" />
            <span>What's New</span>
          </Item>
         <Item href={droneMillInventory} target="_blank" rel="noopener noreferrer">
            <img src={millImg} alt="Mill Inventory" />
            <span>Mill Inventory</span>
        </Item>

        <Item href={workingWithDroneForestApp} target="_blank" rel="noopener noreferrer">
          <img src={forestImg} alt="Forest Inventory" />
          <span>Forest Inventory</span>
        </Item>

        <Item href={multispectralBestPractices} target="_blank" rel="noopener noreferrer">
          <img src={multispectralImg} alt="Multispectral Camera" />
          <span>Multispectral Camera</span>
        </Item>

        <Item href={droneAppRecommendation} target="_blank" rel="noopener noreferrer">
          <img src={landingImg} alt="Tips and Tricks" />
          <span>Tips and Tricks</span>
        </Item>
        </Grid>
      </Container>
    </ContainerWrapper>
  );
}

export default Help;